import {Injectable, Inject} from 'ng-metadata/core'
import {MappingTablesCache} from '../../mappingTablesCache/mappingTablesCache.service';
import {getVid} from '../../appConfig/appConfigForward';


let orderBy= require('lodash/orderBy');

@Injectable()
export class UpFrontActionsService {
    private _requiredUpFrontActionsList: string[]=[];
    public actionIconNamesMap;
    public actionLabelNamesMap;

    //private _actionsToIndex: Object={'none': 0}; // a map from each action to its index in the action tabs. 'none' means all tabs closed
    constructor(private mappingTablesCache: MappingTablesCache,
                @Inject('$translate') private $translate: ng.translate.ITranslateService){
        this.setRequiredUpFrontActionsList();
        this.actionIconNamesMap= {'E-mail': 'email', 'Citation': 'citations', 'Permalink': 'permalink', 'Print': 'print',
                         'EndNote': 'endnote', 'EasyBib': 'easybib', 'RefWorks': 'refworks', 'RISPushTo': 'ris','BibTeXPushTo' : 'bibtex','Mendeley': 'mendeley','Excel': 'excel','QR': 'qr', 'Share': 'share'};

        this.actionLabelNamesMap={'E-mail': 'email', 'Citation': 'citation', 'Permalink': 'permalink', 'Print': 'print',
                                'EndNote': 'pushto.option.EndNote', 'EasyBib': 'pushto.option.EasyBib',
                                'RefWorks': 'pushto.option.RefWorks', 'RISPushTo': 'pushto.option.RISPushTo','BibTeXPushTo':'pushto.option.BibTeXPushTo','Mendeley': 'pushto.option.Mendeley', 'Excel': 'pushto.option.Excel', 'QR': 'pushto.option.qr', 'Share':'pushto.option.share'};
    }

    private setRequiredUpFrontActionsList(){
        let actionsListUnfiltered=  orderBy(this.mappingTablesCache.getTable('Actions List'),(val)=>parseInt(val['source3']), 'desc');
        actionsListUnfiltered= actionsListUnfiltered.filter((val)=>val['source3']);
        let actionsListUnfilteredMyView= actionsListUnfiltered.filter((val)=>val['target'] === getVid());
        actionsListUnfiltered= actionsListUnfilteredMyView.length? actionsListUnfilteredMyView :
                                    actionsListUnfiltered.filter((val)=>val['target'] === 'default');
        actionsListUnfiltered= actionsListUnfiltered.map((config)=>config.source1);
        this._requiredUpFrontActionsList=actionsListUnfiltered.filter((actionName)=>!(actionName==='e-shelf'));
//        for (let i=0; i< this._requiredActionsList.length; i++){
//            this._actionsToIndex[this._requiredActionsList[i]]= i+1;
//        } 
    }

    public get requiredUpFrontActionsList(){
        return this._requiredUpFrontActionsList;
    }

    public getActionIconName(actionName){
        return this.actionIconNamesMap[actionName];
    }

    public getActionLabel(actionName){
        return this.$translate.instant('fulldisplay.command.'+this.actionLabelNamesMap[actionName]);
    }

//    get actionsToIndex(){
//        return this._actionsToIndex;
//    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/briefResult/upFrontActions.service.ts